import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../guards/auth.guard';
import { OrdersalesFisicaListComponent } from './ordersales-fisica-list/ordersales-fisica-list.component';
import { OrderSalesFisicaStep1Component } from './ordersales-fisica-step1/ordersales-fisica-step1.component';
import { OrdersalesFisicaStep1ListComponent } from './ordersales-fisica-step1-list/ordersales-fisica-step1-list.component';
import { OrdersalesFisicaStep2ListComponent } from './ordersales-fisica-step2-list/ordersales-fisica-step2-list.component';
import { OrdersalesFisicaStep3ListComponent } from './ordersales-fisica-step3-list/ordersales-fisica-step3-list.component';
import { OrdersalesFisicaStep4ListComponent } from './ordersales-fisica-step4-list/ordersales-fisica-step4-list.component';

const routesOrderSalesFisica: Routes = [
    { path: 'ordersales-gcf-monitoring', component: OrdersalesFisicaListComponent, canActivate: [AuthGuard] },
    { path: 'ordersales-gcf-step1', component: OrderSalesFisicaStep1Component, canActivate: [AuthGuard] },
    { path: 'ordersales-gcf-step1-list', component: OrdersalesFisicaStep1ListComponent, canActivate: [AuthGuard] },
    { path: 'ordersales-gcf-step2-list', component: OrdersalesFisicaStep2ListComponent, canActivate: [AuthGuard] },
    { path: 'ordersales-gcf-step3-list', component: OrdersalesFisicaStep3ListComponent, canActivate: [AuthGuard] },
    { path: 'ordersales-gcf-step4-list', component: OrdersalesFisicaStep4ListComponent, canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forChild(routesOrderSalesFisica)],
    exports: [RouterModule],
  })
  
  export class OrderSalesFisicaRoutingModule { }